import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconAlert } from '#src/atoms/icons/system/iconAlert.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';

const Wrapper = styled(Horizontal).attrs({ gap: 0, center: true })`
  width: var(--triple-unit);
  height: var(--triple-unit);
  background-color: var(--c-yellow-400);
  border-radius: 100%;
  border: 3px solid var(--c-nd-50);
`;

const Icon = styled(FontAwesomeIcon).attrs({ size: 'sm' })`
  color: var(--c-black);
`;

export const ExclamationIcon = ({ className }: { className?: string }) => {
  return (
    <Wrapper className={className}>
      <Icon icon={iconAlert} />
    </Wrapper>
  );
};
